(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-gammelbrev-signup]').forEach((root) => {
        if (root.dataset.initialized) return;
        root.dataset.initialized = 'true';
        const start = root.querySelector('[data-signup-start]');
        const overlay = root.querySelector('[data-signup-overlay]');
        const panel = overlay.querySelector('[role="dialog"]');
        const closeButton = overlay.querySelector('[data-signup-close]');
        const loading = overlay.querySelector('[data-signup-loading]');
        const embed = overlay.querySelector('.ml-embedded');
        const result = root.querySelector('[data-signup-result]');
        let previousOverflow;
        let opener;
        const synchronize = () => {
          const success = embed.querySelector('.ml-form-successBody');
          if (success && success.style.display !== 'none') {
            start.hidden = true;
            result.hidden = false;
            overlay.querySelector('.gammelbrev-explanation').hidden = true;
            return;
          }
          const field = embed.querySelector('input[name="fields[email]"]');
          if (!field) return;
          loading.hidden = true;

        };
        new MutationObserver(synchronize).observe(embed, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
        document.body.append(overlay);
        start.addEventListener('click', () => {
          opener = document.activeElement;
          synchronize();
          previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          overlay.hidden = false;
          panel.focus();
        });
        const close = () => {
          if (overlay.hidden) return;
          overlay.hidden = true;
          document.body.style.overflow = previousOverflow;
          (!result.hidden ? result : opener?.isConnected ? opener : start).focus();
        };
        closeButton.addEventListener('click', close);
        overlay.addEventListener('click', (event) => { if (event.target === overlay) close(); });
        overlay.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') { event.preventDefault(); close(); }
          if (event.key !== 'Tab') return;
          const items = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), iframe, [tabindex="0"]')].filter((element) => element.getClientRects().length);
          const first = items[0];
          const last = items[items.length - 1];
          if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        });
        synchronize();
        start.hidden = !result.hidden;
        root.querySelector('[data-signup-no-js]').hidden = true;
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movino-erhverv"] && !Shopify.designMode) return;
  try {
    
function setupMovinoGiftDialog() {
  const dialog = document.getElementById('MovinoGiftDialog');
  if (!dialog || dialog.dataset.bound === 'true') return;
  dialog.dataset.bound = 'true';
  let opener;
  const open = (trigger) => {
    opener = trigger;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('mv-gift-open');
    const target = dialog.querySelector('[data-gift-status]') || dialog.querySelector('#InquiryHeading');
    if (target) target.focus();
  };
  document.querySelectorAll('[data-gift-open]').forEach(trigger => {
    trigger.addEventListener('click', event => {
      if (typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      open(trigger);
    });
  });
  dialog.querySelector('[data-gift-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('mv-gift-open');
    if (opener) opener.focus();
  });
  if (dialog.querySelector('[data-gift-status]')) open(document.querySelector('[data-gift-open]'));
}
setupMovinoGiftDialog();
document.addEventListener('shopify:section:load', setupMovinoGiftDialog);

  } catch(e) { console.error(e); }
})();
})();
